var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex houtai"},[_c('headerViewRight',{attrs:{"navList":_vm.routeList}}),_c('section',{staticClass:"section flex-grow-1"},[_c('keep-alive',[(_vm.$route.meta.noCache)?_c('router-view',{key:_vm.key}):_vm._e()],1),(!_vm.$route.meta.noCache)?_c('router-view',{key:_vm.key}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }